import { render, staticRenderFns } from "./accordion-cmp-extended.vue?vue&type=template&id=927616d2&scoped=true&lang=html"
import script from "./accordion-cmp-extended.vue?vue&type=script&lang=js"
export * from "./accordion-cmp-extended.vue?vue&type=script&lang=js"
import style0 from "./accordion-cmp-extended.vue?vue&type=style&index=0&id=927616d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927616d2",
  null
  
)

export default component.exports